var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 36,
    fill: "none",
    viewBox: "0 0 31 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#121212",
    d: "M8.965 20.447c.576-.048.86.237 1.373.449.518.214 1.063.42 1.607.56 1.046.273 2.125.417 3.207.427a12.9 12.9 0 0 0 4.27-.68c.47-.157 1.74-.778 2.086-.76 5.226.27 9.371 5.207 9.237 10.363-.045 1.704.022 2.717-1.258 4.024-1.204 1.227-2.327 1.16-3.886 1.16H5.627c-1.636 0-2.82.18-4.158-.97a4.207 4.207 0 0 1-1.453-2.881c-.035-.51 0-.98 0-1.474 0-2.509.861-4.867 2.516-6.77 1.603-1.846 3.943-3.268 6.433-3.442v-.006ZM15.126-.001c5.306-.131 9.714 4.066 9.851 9.378.138 5.312-4.052 9.73-9.355 9.875-5.316.144-9.74-4.056-9.874-9.378C5.611 4.555 9.81.134 15.126-.001Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.e6a9fd753d2c170c2dce5c57a502e798.svg";
export { ForwardRef as ReactComponent };